export class EsperienzaLavoroDto {
  public IdAnagraficaUtenteEspProf : number = 0;
  public IdAnagraficaUtente : number = 0;
  public TipoContratto : number = 0;
  public TipoContrattoValue : string | null = '';
  public TipoContrattoDesc : string = '';
  public IdAPL : number = 0;
  public APL : string = '';
  public Professione : string = '';
  public IdMansioneList : string = '';
  public IdMansione : number = 0;
  public DataInizio : Date = new Date();
  public DataInizioStr : string = '';
  public MeseInizio : number = 0;
  public AnnoInizio : number = 0;
  public DataFine : Date | null = null;
  public DataFineStr : string = '';
  public MeseFine : number = 0;
  public AnnoFine : number = 0;
  public Azienda : string = '';
  public DescrizioneEsperienzaLavorativa : string = '';
  public ElencoMansioni : string = '';
  public InCorso : boolean = false;
}

export class MansioniDto {
  public IdMansione : number = 0;
  public MansioneDesc : string = '';
  public Mansione : string | null = null;
  public Stato : number = 0;
  public DateIns : Date = new Date();
}

export class AplDto {
  public IdApl : number = 0;
  public AplDesc : string = '';
  public PartitaIva : string = '';
}


